import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  CLIMATE_OVERVIEW_CARD_PANEL_IMPORTS,
  ClimateOverviewCardPanelComponent,
} from 'src/app/panels/components/card/climate-overview-card-panel/climate-overview-card-panel.component';
import { PanelComponent } from 'src/app/panels/components/panel.component';
import { PanelType } from 'src/app/panels/models/panel-type';

@PanelComponent.register
@Component({
  templateUrl:
    './../../../../panels/components/card/climate-overview-card-panel/climate-overview-card-panel.component.html',
  styleUrl:
    './../../../../panels/components/card/climate-overview-card-panel/climate-overview-card-panel.component.scss',
  selector: 'app-indoor-climate-overview-card-panel',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: CLIMATE_OVERVIEW_CARD_PANEL_IMPORTS,
})
export class IndoorClimateOverviewCardPanelComponent extends ClimateOverviewCardPanelComponent {
  public static override readonly type = PanelType.IndoorClimateOverviewCard;
}
